import { create } from 'zustand';
import { LightboxStore } from './types';

const useLightboxStore = create<LightboxStore>((set) => ({
  lightbox: [],

  createLightbox: (newProps) => {
    set((state) => ({
      lightbox: [...state.lightbox, { ...newProps, show: true }],
    }));
  },

  createCustomLightbox: ({ id, render }) => {
    set((state) => ({ lightbox: [...state.lightbox, { id, render }] }));
  },

  destroyLightbox: (id) =>
    set((state) => ({
      lightbox: state.lightbox.filter((item) => item.id !== id),
    })),
}));

export default useLightboxStore;
